import React from 'react';
import { getIconUrl } from '../utils';

const ICON_NAME = 'circle-x';

export const Color = {
  BLACK: 'black',
  DEFAULT: 'black',
};

const CircleXIcon = ({ color = Color.DEFAULT, ...otherProps } = {}) => {
  return (
    <img
      {...otherProps}
      src={getIconUrl({
        name: ICON_NAME,
        color,
      })}
      alt="CircleX Icon"
    />
  );
};

export default CircleXIcon;
